export default {
  callingAPI: false,
  searching: '',
  searchResults: [],
  leakListData: [],
  languageList: [],
  messageList: null,
  messageTypes: [],
  tenantGroupList: [],
  user: null,
  token: null,
  roleID: null,
  secretKey: null,
  username: null,
  password: null,
  dynamics: null,
  otp: null,
  loginError: null,
  otpauth: null,
  // cookie: null,
  loggedInStatus: false,
  isUserLoggedIn: false,
  firstname: null,
  lastname: null,
  updated: null,
  userRoles: [{}],
  signal: 0,
  noSignal: 0,
  currentDevice: null,
  k0: 0,
  k1: 0,
  k2: 0,
  k3: 0,
  k4: 0,
  k5: 0,
  k6: 0,
  k7: 0,
  k8: 0,
  k9: 0,
  k10: 0,
  k11: 0,
  k12: 0,
  k13: 0,
  totalAlert: 0,
  Installed: 0,
  LeakActive: 0,
  LeakInactive: 0,
  Learning: 0,
  Other: 0,
  donutsValues: {
    data: {}
  },
  installsDonut: {
    values: {}
  },
  donutsData: {
    values: {}
  },
  alldonutsData: {
    values: {}
  },
  tenantsList: [],
  devicesList: [],
  workOrderClaimSavings: [],
  leakCategories: [],
  damageCausingRepairs: [],
  repairs: [],
  lowLeakAlerts: [],
  customerFeedback: [],
  marketingMetrics: [],
  ordersAndRegistrations: [],
  monthlyRegistrations: [],
  CostOfProgramme: [],
  lastInvoiceMonth: null,
  leakList: {
    data: {}
  },
  firstTenant: {},
  selectedTenantID: null,
  dropdownDonutsValues: {
    data: {}
  },
  // Auth0 state
  auth0Client: null,
  auth0IsLoading: true,
  auth0IsAuthenticated: false,
  auth0User: {},
  auth0Error: null
}
